import React from 'react';
import { Loader2 } from 'lucide-react';

export const RouteLoadingScreen = ({
  message = 'Loading...',
  backgroundClass = 'bg-[#FAFAF7]',
}) => (
  <div className={`min-h-screen flex items-center justify-center ${backgroundClass}`}>
    <div className="flex flex-col items-center gap-4">
      <Loader2 className="w-10 h-10 text-[#D72B2B] animate-spin" />
      {message ? (
        <p className="text-[#1A2E6E]/70 font-medium">{message}</p>
      ) : null}
    </div>
  </div>
);

export default RouteLoadingScreen;
